import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AgendaListPageComponent } from './agenda-list-page/agenda-list-page.component';
import { AgendaScanPageComponent } from './agenda-scan-page/agenda-scan-page.component';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { CompanyListPageComponent } from './company-list-page/company-list-page.component';
import { EventListPageComponent } from './event-list-page/event-list-page.component';
import { EventScanPageComponent } from './event-scan-page/event-scan-page.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { SplashPageComponent } from './splash-page/splash-page.component';
import { WatermarkPageComponent } from './watermark-page/watermark-page.component';
import { AuthGuard } from './auth.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: SplashPageComponent,
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'login',
        component: LoginPageComponent,
        children: [],
      },
    ],
  },
  {
    path: 'main',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'companies',
        component: CompanyListPageComponent,
        children: [],
      },
      {
        path: 'events/:company_id',
        component: EventListPageComponent,
        children: [],
      },
      {
        path: 'agendas/:company_id',
        component: AgendaListPageComponent,
        children: [],
      },
      {
        path: 'agendas/:company_id/:event_id',
        component: AgendaListPageComponent,
        children: [],
      },
      {
        path: 'scan/event/:company_id/:event_id',
        component: EventScanPageComponent,
        children: [],
      },
      {
        path: 'scan/agenda/:company_id/:event_id/:agenda_id',
        component: AgendaScanPageComponent,
        children: [],
      },
      {
        path: 'watermark/:company_id',
        component: WatermarkPageComponent,
        children: [],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
